import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const paymentInternalService = createApi({
  reducerPath: "paymentInternalService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    updateRefund: builder.mutation<any, any>({
      query: (params) => ({
        url: `/payment-internal/refund`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Payment Internal Refund",
        },
      }),
    }),
    capture: builder.mutation<any, any>({
      query: (params) => ({
        url: `/payment-internal/capture`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Payment Internal Capture",
        },
      }),
    }),
  }),
});

export const {
  useUpdateRefundMutation,
  useCaptureMutation,
} = paymentInternalService;
